import { Option } from "@storeblocks/select";
import { UsabilityCode } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Motorcycle";

export const getBonusOptions = (options: any, lang: string): Option[] => {
  const bonusData = options.bonusData.map(
    (bonus: { displayName: string; value: string }): Option => ({
      label: bonus.displayName,
      value: bonus.value,
    }),
  );
  return [
    {
      label: options.default[lang],
      value: "",
    },
    ...bonusData,
  ];
};

export const getSnowmobileBonusOptions = (
  options: any,
  lang: string,
): Option[] => [
  {
    label: options.default[lang],
    value: "",
  },
  {
    label: options.snowmobileBonus.displayName,
    value: options.snowmobileBonus.value,
  },
];

export const getUsabilityCodeOptions = (
  options: any,
  lang: string,
  age: number,
): Option[] =>
  [
    {
      label: options.defaultLabel[lang],
      value: "",
    },
    {
      label: options.allAges[lang],
      value: UsabilityCode.ALL_AGES,
    },
    age >= 23 && {
      label: options.youngDriver[lang],
      value: UsabilityCode.YOUNG_DRIVER,
    },
    age >= 35 && {
      label: options.adultDriver[lang],
      value: UsabilityCode.ADULT_DRIVER,
    },
  ].filter((option): option is Option => option !== false);
